module.exports = __webpack_public_path__ + "static/media/colormatches.26864fd3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/colormatches.gif
// module id = 49
// module chunks = 0